import { appLogger } from '@/utils/logger';
import { type BoundaryProps, ErrorBoundary } from './ErrorBoundary';

export const ErrorBoundaryDatasets = (props: BoundaryProps) => (
  <ErrorBoundary
    {...props}
    errorMessage="Error loading datasets"
    onRetry={() => {
      appLogger.error('Dataset component removed due to an error.');
    }}
  />
);
